module.exports = __webpack_public_path__ + "fonts/pt-astra-sans_bold.8a56d5ec.ttf";